import { render, staticRenderFns } from "./profile-edit-form.vue?vue&type=template&id=20737a6e&scoped=true&"
import script from "./profile-edit-form.vue?vue&type=script&lang=js&"
export * from "./profile-edit-form.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit-form.vue?vue&type=style&index=0&id=20737a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20737a6e",
  null
  
)

export default component.exports